import Storage from '../../../../assets/js/module/Storage/storage';

const storage = new Storage();
const storageName = 'hh-article-polls-submit';

$(document).ready(() => {
    const userIsSubmitForm = storage.get(storageName).toString().split(',').includes(HH.post_id.toString());

    switchDisplay('form');
    if (userIsSubmitForm) {
        switchDisplay('result')
    }
});

$('.js-hh-article-poll-form').submit((event) => {
    event.preventDefault();

    let blockForm = false;
    const checkedAnswer = $(event.currentTarget).find('input:checked').val();
    const spinner = $(event.currentTarget).find('.js-hh-spinner');
    const buttonTitle = $(event.currentTarget).find('.hh-article-poll__button-title');

    let auth = '';
    if (HH.site_url.includes('dev.pravmir')) {
        auth = 'Basic cHJhdm1pcl9kZXY6Skc4YmZ2eTQ4N3lWVUhoampiYg==';
    }

    buttonTitle.hide();
    spinner.show();
    blockForm = true;

    fetch(HH.site_url + '/wp-json/hh/rest-api/v1/article-poll/' + HH.post_id, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': auth,
        },
        method: 'POST',
        body: JSON.stringify({
            'answer': checkedAnswer,
            'post_id': HH.post_id,
        }),
    }).then(response => {
        buttonTitle.show();
        spinner.hide();

        if (response.status !== 200) {
            throw new Error( 'Problem! Status Code: ' + response.status );
        }

        return response.json();
    }).then(result => {
        blockForm = false;

        updatePollResults(result);

        const ids = storage.get(storageName) ? storage.get(storageName).toString().split(',') : [];

        console.log(ids);
        const newIds = [
            ...ids,
            HH.post_id.toString(),
        ];

        storage.edit(storageName, newIds.join());

        switchDisplay('result');
    });

});

const switchDisplay = (blockForShow) => {
    const formBlock = $('.js-hh-article-poll-form');
    const resultBlock = $('.hh-poll-result');

    if (blockForShow === 'form') {
        formBlock.show();
        resultBlock.hide();
    } else {
        formBlock.hide();
        resultBlock.show();
    }
}

const updatePollResults = (results) => {
    const resultsContainer = $('.hh-poll-result');
    const answers = resultsContainer.find('.hh-poll-result__answers');

    // Считаем все ответы
    const sum = Object.values(results).reduce((currentSum, currentNumber) => {
        return currentSum + currentNumber;
    }, 0);

    Object.keys(results).forEach((key) => {
        const answerContainer = $('#answer_' + key);

        if (! answerContainer.length) {
            return;
        }

        const resultPercent = Math.floor((results[key] / sum) * 100);
        const bar = answerContainer.find('.hh-progress__bar');
        const resultsText = answerContainer.find('.hh-poll-result__percent');

        bar.css('width', resultPercent + '%');
        resultsText.text(resultPercent + '%');
    });


}